import { useRef, useEffect } from 'react';

/**
 * Helper hook to save the previous value of a variable in a ref.
 */
export function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T | undefined>();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}

/**
 *  Helper hook, using usePrevious, that returns true if a value
 *  has changed, and false otherwise.
 *
 */
export function useHasChanged<T>(value: T): boolean {
    const oldValue = usePrevious<T>(value);
    const hasChanged = oldValue !== undefined && oldValue !== value;
    return hasChanged;
}
